import {Injectable} from '@angular/core';
import {HttpHeaders} from '@angular/common/http';
import {environment} from '~/environments/environment';
import {Report} from '~/app/core/reports/models/report';
import {Group} from '~/app/core/reports/models/group';
import {Chain} from '~/app/core/reports/models/chain';
import {ExtractFields} from '~/app/core/reports/models/extractFields';
import {ExtractPost} from "~/app/core/reports/models/extractPost";
import {BaseService} from "~/app/core/services/base.service";
import { map } from 'rxjs/operators';
import { lastValueFrom, Observable } from 'rxjs';


const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};


@Injectable({
  providedIn: 'root'
})

export class ReportService {
  readonly REPORT = 'report';
  readonly RESTPATH = '/fs-online-invoicing-ws/rest/v1';
  readonly ASSGN = '/assigned/'; // {hoId}/{groupid}
  readonly UNASSGN = '/unassigned/'; // {hoId}/{groupid}
  readonly ACCESS = '/complete/' //{hoId}

  groupHeaders: Group[];
  chains: Chain[];

  constructor(
    private baseService: BaseService
  ) {
  }

  getAllReports(userId: string, hotId: string) {
    return this.baseService.getHttpObjectOptions<Report[]>
    (
      'getAllReports',
      'report-service',
      `${environment.base_url}${this.RESTPATH}/${this.REPORT}/all/${hotId}/${userId}`);
  }

  getReportParams(catCode: string, reportId: string) {
    return this.baseService.getHttpObjectOptions<string[]>
    (
      'getReportParams',
      'report-service',
      `${environment.base_url}${this.RESTPATH}/${this.REPORT}/params/${reportId}/${catCode}`);
  }

  getAllExtractFields(hoid: string, reportId: string) {
    return this.baseService.getHttpObjectOptions<ExtractFields[]>
    (
      'getAllExtractFields',
      'report-service',
      `${environment.base_url}${this.RESTPATH}/${this.REPORT}/allextractfields/${hoid}/${reportId}`);
  }

  getSavedExtractList(hoid: string, reportId: string) {
    return this.baseService.getHttpObjectOptions<any>
    (
      'getSavedExtractList',
      'report-service',
      `${environment.base_url}${this.RESTPATH}/${this.REPORT}/extracts/${hoid}/${reportId}`);
  }


  getSavedExtractFields(hoid: string, reportId: string, extractId: string) {
    return this.baseService.getHttpObjectOptions<ExtractFields[]>
    (
      'getSavedExtractFields',
      'report-service',
      `${environment.base_url}${this.RESTPATH}/${this.REPORT}/extractfields/${hoid}/${reportId}/${extractId}`);
  }

  postExtractExport(extractObject: ExtractPost) {
    if (extractObject == null) {
      console.log('Extract Data is empty');
      return;
    }
    return this.baseService.postHttpJsonOptions
    (
      'postExtractExport',
      'report-service',
      `${environment.base_url}${this.RESTPATH}/${this.REPORT}/adhoc/export`, JSON.stringify(extractObject),
      {headers: httpOptions.headers, responseType: 'blob' as 'json'});
  }

  getStores(hotId: string, userId: string) {
      this.baseService.getHttpObjectOptions
      (
        'getStores',
        'report-service',
       `${environment.base_url}${this.RESTPATH}/${this.REPORT}/storegroups/${hotId}/${userId}`)
        .pipe(map((result: []) => {
          const total = [];
          result.forEach((item: any) => {
            const t = new Chain();
            t.field = `${item.chainID} - ${item.storeID}`;
            t.chainID = item.chainID;
            t.storeGroups = item.storeGroups;
            t.storeID = item.storeID;
            t.hoID = item.hoID;
            total.push(t);
          });
          return this.chains=total;
        })).subscribe();
     //return this.removeDuplicates(this.chains, 'storeID');
       return this.chains;
  }

  public removeDuplicates(array: any[], key) {
    return array.filter((v, i, a) => a.findIndex(t => (t[key] === v[key])) === i);
  }

  async getGroupHeaders(hotId: string) {
    if (this.groupHeaders == null) {
      this.groupHeaders =
        await lastValueFrom( this.baseService.getHttpObjectOptions<Group[]>(
          'getGroupHeaders',
          'report-service',
          `${environment.base_url}${this.RESTPATH}/${this.REPORT}/storegrouphdrs/${hotId}`
        )
        );
    }
    return this.groupHeaders;
  }

  postNewExtract(hotid: string, reportId: string, userid: string, extractName: string, fields: []) {
    return this.baseService.postHttpObjectResponse
    (
      'postNewExtract',
      'report-service',
      `${environment.base_url}${this.RESTPATH}/${this.REPORT}/extract/${hotid}/${reportId}/${extractName}/${userid}`,
      fields);
  }

  deleteExtract(hotid: string, reportId: string, extractName: string) {
    return this.baseService
      .deleteHttpResponse(
        'deleteExtract',
        'report-service',
        `${environment.base_url}${this.RESTPATH}/${this.REPORT}/extract/${hotid}/${reportId}/${extractName}`);

  }

  updateExtract(hotid: string, reportId: string, userid: string, extractName: string, extractId: string, fields: []) {
    return this.baseService.putHttpObjectOptions(
      'updateExtract',
      'report-service',
      `${environment.base_url}${this.RESTPATH}/${this.REPORT}/extract/${hotid}/${reportId}/${extractId}/${extractName}/${userid}`,
      fields);
  }

   async getCompleteStoreList(hoId: string) {
   const result = await lastValueFrom (
    this.baseService.getHttpOptionsForReportService
    (
      'getCompleteStoreList',
      'report-service',
      `${environment.base_url}${this.RESTPATH}/${this.REPORT}${this.ACCESS}${hoId}/`)
      .pipe(map((result: []) => {
        const total=[];
        if (result && result.length > 0) {
          result.forEach((item:any ) => {
          const t = new Chain();
          t.field = `${item.chainID} - ${item.storeID}`;
          t.chainID = item.chainID;
          t.storeGroups = [];
          t.storeID = item.storeID;
          t.hoID = item.hoID;
          total.push(t);
        });
       return this.chains=total; 
      }else{
        return [];
      }
      })
      )
    );
    return result;
  }


  getAssignedStores(hotId: string, groupId: string):Observable<Chain[]> {
   return this.baseService.getHttpOptionsForReportService
    (
      'getAssignedStores',
      'report-service',
      `${environment.base_url}${this.RESTPATH}/${this.REPORT}${this.ASSGN}${hotId}/${groupId}`)
      .pipe(map((result: []) => {
        const total = [];
        result.forEach((item: any) => {
          const t = new Chain();
          t.field = `${item.chainID} - ${item.storeID}`;
          t.chainID = item.chainID;
          t.storeGroups = [];
          t.storeID = item.storeID;
          t.hoID = item.hoID;
          total.push(t);
        });
        this.chains=total
        return this.removeDuplicates(this.chains, 'storeID');
      }));
  }


  getUnassignedStores(hotId: string, groupId: string): Observable<Chain[]> {
   return this.baseService.getHttpOptionsForReportService
    (
      'getUnassignedStores',
      'report-service',
      `${environment.base_url}${this.RESTPATH}/${this.REPORT}${this.UNASSGN}${hotId}/${groupId}`)
      .pipe(map((result: []) => {
        const total = [];
        result.forEach((item: any) => {
          const t = new Chain();
          t.field = `${item.chainID} - ${item.storeID}`;
          t.chainID = item.chainID;
          t.storeGroups = [];
          t.storeID = item.storeID;
          t.hoID = item.hoID;
          total.push(t);
        });
        this.chains=total;
        return this.removeDuplicates(this.chains, 'storeID');
      }));
    }
}
